var map = {
	"./cs.json": 114,
	"./de.json": 115,
	"./en.json": 116,
	"./hu.json": 117,
	"./pl.json": 118,
	"./pt.json": 119,
	"./sk.json": 120,
	"./sv.json": 121
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 244;



//////////////////
// WEBPACK FOOTER
// ./lang ^\.\/.*\.json$
// module id = 244
// module chunks = 3